import React, { useContext, useEffect } from 'react'
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { useVoiceAgentStore } from '../../../store/voiceAgentStore';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { initialCreateAgentPayload, buildDefaultVoiceAgentFieldData, getDefaultLanguageAndVoice } from './voiceAgentConstants';

const VoiceAgentDetails = () => {
    const { handleError, setFlagLoading, languageList } = useContext(UserContext) as UserContextPayload;
    const { getVoiceAgentsModelList } = useContext(GenericDataContext) as GenericDataContextPayload;
    const [searchParams] = useSearchParams();
    const agentId = searchParams.get('voice_agent_id');
    const navigate = useNavigate();

    const getVoiceAgentDetailAPI = useVoiceAgentStore((state) => state.getVoiceAgentDetailAPI);
    const getAIAgentVoicesAPI = useVoiceAgentStore((state) => state.getAIAgentVoicesAPI);
    const setCreateAgentPayload = useVoiceAgentStore((state) => state.setCreateAgentPayload);
    const tempCreateAgentPayload = useVoiceAgentStore((state) => state.tempCreateAgentPayload);
    const setVoiceAgentDetail = useVoiceAgentStore((state) => state.setVoiceAgentDetail);
    const voiceAgentFieldData = useVoiceAgentStore((state) => state.voiceAgentFieldData);

    const getVoiceAgentDetailsAPICall = async () => {
        const res = await getVoiceAgentDetailAPI(agentId || "");
        if(!(res.status)){
            handleError(res);
            navigate('/voiceagent')
        }
    }

    const aiAgentVoiceData = async () => {
        const res = await getAIAgentVoicesAPI();
        if(!(res.status)){
            handleError(res);
        }
    }

    useEffect(() => {
        (async () => {
            setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
            await getVoiceAgentsModelList()
            await aiAgentVoiceData()
            if (agentId) {
                await getVoiceAgentDetailsAPICall();
            }
            else {
                handleResetPayload()
            }
            setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
        })()
    }, [agentId, window.location.pathname]);

    const handleResetPayload = () => {
        if (agentId) {
            setCreateAgentPayload(tempCreateAgentPayload)
        }
        else {
            const { language_id, ai_agent_voice_id } = getDefaultLanguageAndVoice(
                languageList,
                useVoiceAgentStore.getState().aiAgentVoices
            );
            setCreateAgentPayload({
                ...initialCreateAgentPayload,
                voice_agent_detail: {
                    ...initialCreateAgentPayload.voice_agent_detail,
                    language_id,
                    ai_agent_voice_id,
                },
                voice_agent_field_data: buildDefaultVoiceAgentFieldData(voiceAgentFieldData),
            })
            setVoiceAgentDetail(null);
        }
    }

    return (
        <>
            <Outlet />
        </>
    )
}

export default VoiceAgentDetails
